// First-impression copy shown by the root `cloudgrid` command. Kept in one
// module so the strings are unit-testable (index.ts runs the CLI on import and
// can't be imported in a test) and so a future polish pass has a single place
// to tune them. §23: plain, specific, confident, no marketing adjectives, no
// emoji, no exclamation marks.

/**
 * The one-line program description — the first thing a new builder sees when
 * they type `cloudgrid`. Concrete verb, no hedging about what isn't built yet.
 */
export const PROGRAM_DESCRIPTION = 'Put your apps and agents on the grid.';

/**
 * First-run orientation appended under the help command list. Three commands,
 * one path to a live URL. §23b: friendly, brief, one suggestion.
 */
export const FIRST_RUN_HELP = [
  '',
  'New here? Three commands to your first live URL:',
  '  cloudgrid login              sign in',
  '  cloudgrid init app <name>    start an app',
  '  cloudgrid plug               build it and go live',
].join('\n');
